import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { injectCustomIdParameter } from "@utils/parameter-injector";
import { MessagingTemplate } from "@idw-types/data/messaging-template";
import { MESSAGING_TEMPLATE_ID_PATTERN } from "@constants/url-parameter-patterns";

export const getMessagingTemplateRequest = async (messagingTemplateId: string): Promise<{ data: MessagingTemplate, error: any }> => {
    const route = injectCustomIdParameter(apiRoutes.axnadminCore.messagingTemplateWithId, messagingTemplateId, MESSAGING_TEMPLATE_ID_PATTERN);
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};